import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';

import AdminPage from './Admin/AdminPage';
import AdminLogin from './Admin/Login';
import Policy from './Admin/Policy';
import QrCode from './Admin/QrCode';
import Redirector from './Admin/QrCodeInstall';

function App() {
  const location = useLocation();

  const isAdminPage = location.pathname.startsWith("/admin");

  useEffect(() => {
    document.body.style.backgroundColor = isAdminPage ? 'white' : '#F3F4F6';
  }, [isAdminPage]);

  return (
    <div>
      <main>
        <Routes>
          <Route path="/" element={<Navigate to="/admin/home" replace />} />

          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/privacy" element={<Policy />} />
          <Route path="/link" element={<QrCode />} />
          <Route path="/link/install" element={<Redirector />} />

          
          <Route path="/admin/*" element={<AdminPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;